import * as React from 'react';
import { isNil } from 'ramda';
import { Tabs } from '@cian/ui-kit/prev';
import { getDirectionStations } from '../../../utils/stations';
import { trackRailwayDirectionChanged } from '../tracking';
import { TStationDirectionsProps } from './container';

import * as styles from './index.css';

export class StationDirections extends React.Component<TStationDirectionsProps> {
  public render() {
    const {
      stations,
      stations: { directions = [], selectedDirection, selectedStations },
    } = this.props;

    if (directions.length < 2) {
      return null;
    }

    const tabs = directions.map(({ id, name }) => {
      const directionStations = !isNil(id) ? getDirectionStations(stations.currentStations, id) : [];
      const selectedStationsCounter = directionStations.filter(item => selectedStations.includes(item.id));

      const title = selectedStationsCounter.length ? <span className={styles['badge']}>{name}</span> : name;

      return {
        value: String(id),
        // HACK для того, чтобы добавить badge для таба
        title: title as unknown as string,
      };
    });

    return <Tabs tabs={tabs} activeTab={String(selectedDirection)} onChange={this.handleDirectionChange} />;
  }

  private handleDirectionChange = (id: string) => {
    this.props.onChangeStationDirection(+id);
    trackRailwayDirectionChanged();
  };
}
